export default __webpack_public_path__ + "static/media/flag-slovenia.a9d43f9a.svg";